import { isArray } from 'lodash';
import {
  deleteChartSeriesAction,
  addChartSeriesAction,
  updateChartSeriesAction
} from 'pages/ChartEditorPage/actions/chartEditor';
import {
  deleteAssignRawOptionAction,
  addAssignRawOptionAction,
  updateAssignRawOptionAction
} from 'pages/TableEditorPage/actions/tableEditor';
import { Action } from 'redux';
import { SeriesAssign } from 'shared/types/commonPropTypes';

const deleteBlacklist = [
  'candlestick',
  'tilemap',
  'pie',
  'ohlc',
  'item',
  'dependencywheel',
  'sankey',
  'wordcloud',
  'vector',
  'boxplot',
  'timeline',
  'heatmap',
  'packedbubble',
  'funnel',
  'solidgauge',
  'map',
  'treemap'
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dateFormatBlacklist = [
  'tilemap',
  'pie',
  'item',
  'dependencywheel',
  'sankey',
  'wordcloud',
  'vector',
  'timeline',
  'heatmap',
  'packedbubble',
  'funnel',
  'solidgauge',
  'treemap',
  'columnrange'
];

export const getSeriesType = (aggregatedOptions: any): string[] => {
  return (aggregatedOptions.series ?? []).map((serie: { type?: string }) => {
    if (serie.type) return serie.type;
    if (aggregatedOptions.chart?.type) return aggregatedOptions.chart.type;
    if (aggregatedOptions.chart?.map) return 'map';
    return 'line';
  });
};
export const getAllowProps = (aggregatedOptions: Record<string, unknown>, isTable?: boolean) => {
  if (isTable) return { allowAddSeries: true, seriesTypes: [] };

  const seriesTypes = getSeriesType(aggregatedOptions);
  let allowAddSeries = true;

  seriesTypes.forEach((type: string) => {
    if (deleteBlacklist.includes(type)) allowAddSeries = false;
  });
  return { allowAddSeries, seriesTypes };
};

export const getIsLiveDataSource = (
  aggregatedOptions: any,
  dataConfig: {
    googleSpreadsheetKey: string;
  }
) => {
  if (dataConfig?.googleSpreadsheetKey) return true;
  return (
    aggregatedOptions.data &&
    (aggregatedOptions.data.csvURL ??
      aggregatedOptions.data.rowsURL ??
      aggregatedOptions.data.columnsURL ??
      aggregatedOptions.data.googleSpreadsheetKey)
  );
};

export const isUsingChartType = (aggregatedOptions: any, type: string) => {
  return (
    aggregatedOptions?.chart?.type === type ||
    (isArray(aggregatedOptions?.series) &&
      aggregatedOptions.series.some((series: { type: string }) => series.type === type))
  );
};

export const getMappedValues = (assignOptions: Record<string, SeriesAssign>, isAdvanced: boolean) => {
  const columns: string[] = [];
  const series: number[] = [];
  Object.values(assignOptions).forEach((value) => {
    if ((value.isData || (isAdvanced && value.isExtra)) && !value.hidden) {
      if (value.rawValue) {
        columns.push(value.value);
        series.push(value.rawValue?.[0] ?? null);
      }
    }
  });
  return { columns, series };
};

export const deleteSeriesTypes: Record<string, (data: unknown) => Action> = {
  chart: deleteChartSeriesAction,
  table: deleteAssignRawOptionAction
};

export const addSeriesTypes: Record<string, (data: unknown) => Action> = {
  chart: addChartSeriesAction,
  table: addAssignRawOptionAction
};

export const updateSeriesTypes: Record<string, (data: unknown) => Action> = {
  chart: updateChartSeriesAction,
  table: updateAssignRawOptionAction
};
